export default __webpack_public_path__ + "bb9e1f780ecf3a10da70d7262cf2252a.svg";